<template>
    <CCard>
        <CCardHeader>
            <strong>Ответственные лица</strong>
        </CCardHeader>
        <CCardBody>
            <div class="overflow-hidden">
                <div class="flex items-center h-10 py-4">
                    <div class="w-3/12 truncate px-2">Курьер:</div>
                    <div class="w-6/12 py-2">
                        <span
                            v-if="order && order.courier"
                            class="text-purple-700 cursor-pointer hover:underline"
                            :title="order.courier.name"
                            @click="$router.push(`/couriers/${order.courier.id}`)"
                        >
                            {{ order.courier.name }}
                            <span
                                :class="{
                                    dot: true,
                                    seen: order.courier_approve
                                }"></span>
                        </span>
                        <span v-else> Не назначено </span>
                    </div>
                    <div class="w-3/12">
                        <CButton color="primary" @click="setCourierModal = true">{{
                            order.courier ? "Изменить" : "Назначить"
                        }}</CButton>
                    </div>
                </div>
                <div class="flex items-center h-10 py-4">
                    <div class="w-3/12 truncate px-2">Консьерж:</div>
                    <div class="w-6/12 py-2">
                        <span
                            v-if="order && order.concierge"
                            class="text-purple-700 cursor-pointer hover:underline"
                            :title="order.concierge.name"
                            @click="$router.push(`/concierges/${order.concierge.id}`)"
                        >
                            {{ order.concierge.name }}
                            <span
                                :class="{
                                    dot: true,
                                    seen: order.concierge_approve
                                }"></span>
                        </span>
                        <span v-else> Не назначено </span>
                    </div>
                    <div class="w-3/12">
                        <CButton color="primary" @click="setConciergeModal = true">{{
                            order.concierge ? "Изменить" : "Назначить"
                        }}</CButton>
                    </div>
                </div>

                <!-- Блок предложенных исполнителей -->
                 <div>
                    Предложенные исполнители:
                 </div>
                <div class="flex items-center py-2">
                    <div class="w-3/12 truncate px-2">Курьер:</div>
                    <div class="w-6/12 py-2">
                        <span v-if="suggestions.courier">{{ suggestions.courier.name }}</span>
                        <span v-else>Не найден</span>
                    </div>
                    <div class="w-3/12">
                        <CButton v-if="suggestions.courier" color="success" size="sm" @click="assignSuggestedCourier">
                            Назначить
                        </CButton>
                    </div>
                </div>
                <div class="flex items-center py-2">
                    <div class="w-3/12 truncate px-2">Консьерж:</div>
                    <div class="w-6/12 py-2">
                        <span v-if="suggestions.concierge">{{ suggestions.concierge.name }}</span>
                        <span v-else>Не найден</span>
                    </div>
                    <div class="w-3/12">
                        <CButton v-if="suggestions.concierge" color="success" size="sm" @click="assignSuggestedConcierge">
                            Назначить
                        </CButton>
                    </div>
                </div>

                <!-- Начало нового блока для дополнительных назначенных пользователей -->
                <div class="flex items-center py-4 mt-2">
                    <div class="w-full">
                        <div class="flex justify-between items-center">
                            <strong class="text-gray-700">Дополнительные назначенные лица:</strong>
                            <CButton color="success" size="sm" @click="showAddAssigneeModal">Добавить</CButton>
                        </div>
                        
                        <div v-if="additionalAssignees.length" class="mt-2">
                            <div v-for="(assignee, index) in additionalAssignees" :key="index" class="flex items-center py-2 border-b border-gray-200">
                                <div class="w-4/12">
                                    <span class="text-purple-700 cursor-pointer hover:underline" 
                                          @click="navigateToUser(assignee)">
                                        {{ assignee.user_details ? assignee.user_details.name : `ID: ${assignee.user_id}` }}
                                    </span>
                                </div>
                                <div class="w-3/12">
                                    {{ assignee.type === 'courier' ? 'Курьер' : 'Консьерж' }}
                                </div>
                                <div class="w-3/12">
                                    <span :class="{ 'text-green-500': assignee.alert, 'text-red-500': !assignee.alert }">
                                        {{ assignee.alert ? 'Уведомлен' : 'Не уведомлен' }}
                                    </span>
                                </div>
                                <div class="w-2/12 flex justify-end">
                                    <CButton color="danger" size="sm" @click="removeAssignee(assignee)">Удалить</CButton>
                                </div>
                            </div>
                        </div>
                        <div v-else class="mt-2 text-gray-500">
                            Нет дополнительных назначенных лиц
                        </div>

                        <div v-if="additionalAssignees.length" class="mt-3">
                            <CButton color="primary" size="sm" @click="sendAlertsToAll">Отправить уведомления всем</CButton>
                        </div>
                    </div>
                </div>
                <!-- Конец нового блока для дополнительных назначенных пользователей -->
            </div>
        </CCardBody>

        <CModal
            title="Назначить курьера"
            :show.sync="setCourierModal"
            :footer="false"
            color="info"
        >
            <template>
                <CDropdown
                    color="light"
                    :toggler-text="order.courier_id ? order.courier.name : 'Выберите курьера'"
                    size="lg"
                    class="custom__dropdown"
                >
                        <template v-if="couriersOptions.length > 0">
                            <CDropdownItem
                                v-for="courier in couriers"
                                :key="courier.id"
                                :disabled="!!courier.at_lunch"
                                @click.prevent="courier.at_lunch ? () => false : setCourier(courier.id)"
                            >
                                <div class="custom__dropdown__item">
                                    <div class="custom__dropdown__item__name">
                                        <strong>{{ courier.name }}</strong>
                                        <span v-if="courierQueueSettings.updated && courier.geo" class="">
                                            Локации обновлены: <strong>{{ getTimeRemaining(courier.geo.updated_at) }} назад.</strong>
                                        </span>
                                    </div>
                                    <div class="custom__dropdown__item__info">
                                        <ul>
                                            <li v-if="courierQueueSettings.status && courier.id"> 
                                                <!-- at_lunch -->
                                                Статус: <strong
                                                    :class="{
                                                        green: !courier.busy,
                                                        red: courier.busy,
                                                        yellow: courier.at_lunch,
                                                    }">{{
                                                    courier.at_lunch ? 'На перерыве' : courier.busy ? 'Занят' : 'Свободен'
                                                }}</strong>
                                            </li>
                                            <li v-if="courierQueueSettings.orderIds && courier.orderIds && courier.orderIds.length">
                                                Выполняет: <strong>{{ courier.orderIds.join(', ') }}</strong>
                                            </li>
                                            <li v-if="courierQueueSettings.now_at && courier.geo && !courier.at_lunch">
                                                Находится в: <strong>{{ courier.geo.now_at ? towersMap[courier.geo.now_at] : 'Не найдено' }}</strong>
                                            </li>
                                            <li v-if="courierQueueSettings.go_to && courier.geo && (!courier.at_lunch && courier.busy)">
                                                Направляется в: <strong>{{ courier.geo.go_to ? towersMap[courier.geo.go_to] : 'Не найдено' }}</strong>
                                            </li>
                                        </ul>
                                        <hr />
                                    </div>
                                    
                                </div>
                            </CDropdownItem>
                        </template>
                        <template v-else>
                            <CDropdownItem>
                                На смене нет курьеров.
                            </CDropdownItem>
                        </template>
                </CDropdown>
            </template>
        </CModal>

        <CModal
            title="Назначить консьержа"
            :show.sync="setConciergeModal"
            :footer="false"
            color="info"
        >
            <template>
                <CDropdown
                    color="light"
                    :toggler-text="order.concierge_id ? order.concierge.name : 'Выберите консьержа'"
                    size="lg"
                    class="custom__dropdown"
                >
                        <template v-if="concierges.length > 0">
                            <CDropdownItem
                                v-for="concierge in concierges"
                                :key="concierge.id"
                                :disabled="!!concierge.at_lunch"
                                @click.prevent="concierge.at_lunch ? () => false : setConcierge(concierge.id)"
                            >
                                <div class="custom__dropdown__item">
                                    <div class="custom__dropdown__item__name">
                                        <strong>{{ concierge.name }}</strong>
                                    </div>
                                    <div class="custom__dropdown__item__info">
                                        <ul>
                                            <li v-if="concierge.id"> 
                                                <!-- at_lunch -->
                                                Статус: <strong
                                                    :class="{
                                                        yellow: concierge.at_lunch,
                                                    }">{{
                                                    concierge.at_lunch ? 'На перерыве' : 'На смене'
                                                }}</strong>
                                            </li>
                                        </ul>
                                        <hr />
                                    </div>
                                </div>
                            </CDropdownItem>
                        </template>
                        <template v-else>
                            <CDropdownItem>
                                На смене нет консьержей.
                            </CDropdownItem>
                        </template>
                </CDropdown>
            </template>
        </CModal>

        <!-- Начало модального окна для добавления дополнительного назначенного лица -->
        <CModal
            title="Добавить дополнительное назначенное лицо"
            :show.sync="addAssigneeModal"
            :footer="false"
            color="success"
        >
            <div class="p-4">
                <div class="mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2">Тип</label>
                    <div class="flex">
                        <button 
                            class="px-4 py-2 mr-2" 
                            :class="{'bg-green-500 text-white': newAssignee.type === 'courier', 'bg-gray-200': newAssignee.type !== 'courier'}"
                            @click="newAssignee.type = 'courier'; newAssignee.user_id = null;"
                        >
                            Курьер
                        </button>
                        <button 
                            class="px-4 py-2" 
                            :class="{'bg-green-500 text-white': newAssignee.type === 'concierge', 'bg-gray-200': newAssignee.type !== 'concierge'}"
                            @click="newAssignee.type = 'concierge'; newAssignee.user_id = null;"
                        >
                            Консьерж
                        </button>
                    </div>
                </div>

                <!-- Секция выбора курьера - показывается только если выбран тип "courier" -->
                <div class="mb-4" v-if="newAssignee.type === 'courier'">
                    <label class="block text-gray-700 text-sm font-bold mb-2">
                        Выберите курьера
                    </label>
                    <div v-if="allCouriers.length === 0" class="text-red-500">
                        Загрузка списка курьеров...
                    </div>
                    <select 
                        v-else 
                        v-model="newAssignee.user_id" 
                        class="w-full px-3 py-2 border rounded"
                    >
                        <option value="" disabled selected>Выберите курьера</option>
                        <option 
                            v-for="courier in allCouriers" 
                            :key="courier.id" 
                            :value="courier.id"
                        >
                            {{ courier.name }}
                            {{ courier.at_lunch ? ' (На перерыве)' : 
                               courier.busy ? ' (Занят)' : 
                               !courier.online ? ' (Не на смене)' : '' }}
                        </option>
                    </select>
                    <div class="mt-2 text-gray-600">
                        Всего курьеров: {{ allCouriers.length }}
                    </div>
                </div>

                <!-- Секция выбора консьержа - показывается только если выбран тип "concierge" -->
                <div class="mb-4" v-if="newAssignee.type === 'concierge'">
                    <label class="block text-gray-700 text-sm font-bold mb-2">
                        Выберите консьержа
                    </label>
                    <div v-if="allConcierges.length === 0" class="text-red-500">
                        Загрузка списка консьержей...
                    </div>
                    <select 
                        v-else 
                        v-model="newAssignee.user_id" 
                        class="w-full px-3 py-2 border rounded"
                    >
                        <option value="" disabled selected>Выберите консьержа</option>
                        <option 
                            v-for="concierge in allConcierges" 
                            :key="concierge.id" 
                            :value="concierge.id"
                        >
                            {{ concierge.name }}
                            {{ concierge.at_lunch ? ' (На перерыве)' : 
                               !concierge.online ? ' (Не на смене)' : '' }}
                        </option>
                    </select>
                    <div class="mt-2 text-gray-600">
                        Всего консьержей: {{ allConcierges.length }}
                    </div>
                </div>

                <div class="flex justify-end mt-6">
                    <CButton color="secondary" class="mr-2" @click="addAssigneeModal = false">Отмена</CButton>
                    <CButton color="success" :disabled="!newAssignee.type || !newAssignee.user_id" @click="addAssignee">Добавить</CButton>
                </div>
            </div>
        </CModal>
        <!-- Конец модального окна для добавления дополнительного назначенного лица -->

        <!-- Модальное окно с результатами отправки уведомлений -->
        <CModal
            title="Результаты отправки уведомлений"
            :show.sync="alertResultsModal"
            :footer="false"
            color="info"
        >
            <div class="p-4">
                <div v-if="alertResults.success_count !== undefined" class="mb-4">
                    <p class="font-bold">Отправлено успешно: {{ alertResults.success_count }} из {{ alertResults.total_count }}</p>
                </div>
                <div v-if="alertResults.results && alertResults.results.length">
                    <h4 class="font-bold mb-2">Детали:</h4>
                    <ul class="list-disc pl-4">
                        <li v-for="(result, index) in alertResults.results" :key="index" class="mb-2">
                            <div :class="{'text-green-500': result.result, 'text-red-500': !result.result}">
                                {{ result.name || `ID: ${result.user_id}` }} ({{ result.type === 'courier' ? 'Курьер' : 'Консьерж' }}): 
                                {{ result.result ? 'Успешно' : `Ошибка: ${result.error || 'Неизвестная ошибка'}` }}
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="flex justify-end mt-4">
                    <CButton color="secondary" @click="alertResultsModal = false">Закрыть</CButton>
                </div>
            </div>
        </CModal>
    </CCard>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import countdown from 'countdown';
    require('moment-countdown');

    export default {
        name: 'OrderPersons',

        components: {},

        props: {
            id: {
                type: Number,
                default: null
            },
            order: {
                type: Object,
                default: () => ({})
            },
        },

        data() {
            return {
                isAuthorized: false,
                setCourierModal: false,
                setConciergeModal: false,
                couriers: [],
                courierQueueSettings: {},
                concierges: [],
                towersMap: {},
                // Новые данные для дополнительных назначенных лиц
                additionalAssignees: [],
                addAssigneeModal: false,
                newAssignee: {
                    type: '',
                    user_id: null
                },
                allCouriers: [], // Все курьеры, включая тех, кто не на смене
                allConcierges: [], // Все консьержи, включая тех, кто не на смене
                alertResultsModal: false,
                alertResults: {},
                suggestions: {
                    courier: null,
                    concierge: null,
                }
            };
        },

        computed: {
            couriersOptions() {
                return this.couriers.length > 0 ? this.couriers.map(el => {
                    return { value: el.id, label: el.name };
                }) : [];
            },
            conciergesOptions() {
                return this.concierges.map(el => {
                    return { value: el.id, label: el.name };
                });
            },
            // Опции для выбора курьеров и консьержей в модальном окне добавления
            courierSelectOptions() {
                console.log(this.allCouriers, 'allCouriersallCouriersallCouriers');
                
                return this.allCouriers.results.map(courier => {
                    const statusText = courier.at_lunch ? ' (На перерыве)' : 
                                     courier.busy ? ' (Занят)' : 
                                     !courier.online ? ' (Не на смене)' : '';

                                     console.log(allCouriers, 'allCouriers');
                                     
                    return { 
                        value: courier.id, 
                        label: courier.name + statusText,
                        disabled: false // Разрешаем назначать любых курьеров как дополнительных
                    };
                });
            },
            conciergeSelectOptions() {
                return this.allConcierges.map(concierge => {
                    const statusText = concierge.at_lunch ? ' (На перерыве)' : 
                                      !concierge.online ? ' (Не на смене)' : '';
                    return { 
                        value: concierge.id, 
                        label: concierge.name + statusText,
                        disabled: false // Разрешаем назначать любых консьержей как дополнительных
                    };
                });
            }
        },

        watch: {
            setCourierModal: 'fetch',
            // Сбрасываем форму при закрытии модального окна
            addAssigneeModal(newVal) {
                if (!newVal) {
                    this.newAssignee = {
                        type: '',
                        user_id: null
                    };
                } else {
                    this.fetchAllCouriersAndConcierges();
                }
            }
        },

        mounted() {
            this.fetch();
            this.fetchAdditionalAssignees();
            this.fetchSuggestions();
        },

        methods: {
            setCourier(id) {
                Vue.axios
                    .put('/orders/' + this.id + '/courier', { courier: id })
                    .then(resp => {
                        location.reload();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка назначения курьера. ' + err);
                    });
            },
            setConcierge(id) {
                Vue.axios
                    .put('/orders/' + this.id + '/concierge', { concierge: id })
                    .then(resp => {
                        location.reload();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка назначения консьержа. ' + err);
                    });
            },
            async fetch() {
                try {
                    this.couriers = (await Vue.axios.get(`/couriers?enabled=1&online=1&orderId=${this.id}`))?.data.results;
                    this.couriers.unshift({id: null, name: 'Убрать курьера'});
                    const settings = await Vue.axios.get('/couriers/service/courier-queue');
                    this.courierQueueSettings = settings?.data?.id ? settings?.data : {};
    
                    this.concierges = (await Vue.axios.get('/concierges?enabled=1&online=1'))?.data.results;
                    this.concierges.unshift({id: null, name: 'Убрать консьержа'});

                    Vue.axios.get(`/couriers?fromService=true&enabled=1&online=1&orderId=${this.id}`).then(resp => {
                        if(resp?.data) {
                            this.couriers = resp.data;
                            this.couriers.unshift({id: null, name: 'Убрать курьера'});
                        }
                    });

                    const address = await Vue.axios.get('/address');
                    this.towersMap = address.data.reduce((towers, tower) => {
                        towers[tower.id] = tower.name;
                        return towers;
                    }, {});
                } catch (error) {
                    console.log(error, 'error');
                    this.$root.$emit('showError', 'Ошибка загрузки ответственных лиц.')
                }
            },

            getTimeRemaining(date) {
                const isNow = (new Date().getTime() - new Date(moment(date)).getTime()) <= 1000 * 60;
                if (isNow) {
                    return 'меньше минуты'
                }
                return countdown(
                    new Date(),
                    new Date(moment(date)),
                    countdown.DAYS | countdown.HOURS | countdown.MINUTES
                )
            },

            // Новые методы для работы с дополнительными назначенными лицами
            async fetchSuggestions() {
                try {
                    const resp = await Vue.axios.get(`/orders/${this.id}/suggestions`);
                    if (resp.data && resp.data.success) {
                        this.suggestions = resp.data.data || { courier: null, concierge: null };
                    }
                } catch (e) {
                    // молча игнорируем подсказки, если недоступно
                }
            },

            assignSuggestedCourier() {
                if (this.suggestions.courier?.id) {
                    this.setCourier(this.suggestions.courier.id);
                }
            },
            assignSuggestedConcierge() {
                if (this.suggestions.concierge?.id) {
                    this.setConcierge(this.suggestions.concierge.id);
                }
            },
            async fetchAdditionalAssignees() {
                try {
                    const response = await Vue.axios.get(`/orders/${this.id}/assignees`);
                    if (response.data && response.data.success) {
                        this.additionalAssignees = response.data.data || [];
                    }
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка загрузки дополнительных назначенных лиц. ' + error);
                }
            },

            async fetchAllCouriersAndConcierges() {
                try {
                    // Явно устанавливаем пустые массивы перед загрузкой
                    this.allCouriers = [];
                    this.allConcierges = [];

                    // Получаем курьеров
                    const couriersResponse = await Vue.axios.get('/couriers');
                    console.log('Ответ API курьеров:', couriersResponse.data);
                    
                    // Правильно извлекаем курьеров из объекта с results
                    if (couriersResponse.data && couriersResponse.data.results && Array.isArray(couriersResponse.data.results)) {
                        this.allCouriers = couriersResponse.data.results;
                    } else if (Array.isArray(couriersResponse.data)) {
                        this.allCouriers = couriersResponse.data;
                    }
                    
                    // Получаем консьержей
                    const conciergesResponse = await Vue.axios.get('/concierges');
                    console.log('Ответ API консьержей:', conciergesResponse.data);
                    
                    // Правильно извлекаем консьержей из объекта с results
                    if (conciergesResponse.data && conciergesResponse.data.results && Array.isArray(conciergesResponse.data.results)) {
                        this.allConcierges = conciergesResponse.data.results;
                    } else if (Array.isArray(conciergesResponse.data)) {
                        this.allConcierges = conciergesResponse.data;
                    }
                    
                    console.log('Финальные списки:');
                    console.log('Курьеры:', this.allCouriers.length, 'элементов');
                    console.log('Консьержи:', this.allConcierges.length, 'элементов');
                } catch (error) {
                    console.error('Ошибка загрузки списков:', error);
                    this.$root.$emit('showError', 'Ошибка загрузки списка сотрудников. ' + error);
                }
            },

            showAddAssigneeModal() {
                // Сбрасываем форму перед открытием
                this.newAssignee = {
                    type: '',
                    user_id: null
                };
                this.addAssigneeModal = true;
            },

            async addAssignee() {
                try {
                    const response = await Vue.axios.post(`/orders/${this.id}/assignees`, this.newAssignee);
                    if (response.data && response.data.success) {
                        this.$root.$emit('showSuccess', 'Дополнительное лицо успешно назначено');
                        this.addAssigneeModal = false;
                        this.fetchAdditionalAssignees(); // Обновляем список
                    }
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка назначения дополнительного лица. ' + (error.response?.data?.error || error.message || error));
                }
            },

            async removeAssignee(assignee) {
                if (confirm(`Вы уверены, что хотите удалить ${assignee.type === 'courier' ? 'курьера' : 'консьержа'} ${assignee.user_details?.name || ''}?`)) {
                    try {
                        const response = await Vue.axios.delete(
                            `/orders/${this.id}/assignees/${assignee.user_id}`, 
                            { data: { type: assignee.type } }
                        );
                        if (response.data && response.data.success) {
                            this.$root.$emit('showSuccess', 'Дополнительное лицо успешно удалено');
                            this.fetchAdditionalAssignees(); // Обновляем список
                        }
                    } catch (error) {
                        this.$root.$emit('showError', 'Ошибка удаления дополнительного лица. ' + (error.response?.data?.error || error.message || error));
                    }
                }
            },

            async sendAlertsToAll() {
                try {
                    const response = await Vue.axios.post(`/orders/${this.id}/assignees/send-alerts`);
                    if (response.data && response.data.success) {
                        this.alertResults = response.data.data || {};
                        this.alertResultsModal = true;
                        this.fetchAdditionalAssignees(); // Обновляем список, чтобы обновить статусы alert
                    }
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка отправки уведомлений. ' + (error.response?.data?.error || error.message || error));
                }
            },

            navigateToUser(assignee) {
                if (assignee.user_details && assignee.user_details.id) {
                    if (assignee.type === 'courier') {
                        this.$router.push(`/couriers/${assignee.user_details.id}`);
                    } else {
                        this.$router.push(`/concierges/${assignee.user_details.id}`);
                    }
                }
            }
        },
    };
</script>

<style scoped>
.dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    vertical-align: middle;

    vertical-align: middle;

    background: red;

    border-radius: 50%;
}
.dot.seen {
    background: #23d923;
}
.red {
    color: red;
}
.green {
    color: #23d923;
}
.yellow {
    color: #f6bb36;
}
</style>
<style lang="scss">
.custom__dropdown {
    .btn.dropdown-toggle {
        width: 100%;
    }
    .dropdown-menu.show {
        width: 100%;
    }

    &__item {
        width: 100%;

        hr {
            margin: 5px 0;
        }

        &__name {
            display: flex;
            align-items: center;
            justify-content: space-between;
            white-space: normal;

            span {
                font-size: 12px;
            }
        }

        &__info {
            width: 100%;
            // max-width: 200px;

            ul {
                li {
                    white-space: normal;
                }
            }
        }
    }
}
</style>
